import React, { useEffect, useState } from "react"
import { Card, Col, Container, Row, CardBody, CardTitle } from "reactstrap"

import { Link, useNavigate, useParams } from "react-router-dom"
import leftArrow from "../../../assets/images/icons/left-arrow.svg"
import NonIndividualView from "./nonIndividualView"
import { getInvestorsStatus } from "helpers/common"
import LoaderComponent from "components/loader"
import { useLazyGetReferalQuery } from "store/api/wealthpartnerapi/referrals/referrals.api"
import RaisedQueries from "pages/Investors/raisedQueries"

const InvestorManagementInviteView = () => {
  const { id } = useParams()
  const history = useNavigate()
  const [getResult, { isFetching }] = useLazyGetReferalQuery()
  const [investorData, setInvestorData] = useState(null)

  useEffect(() => {
    if (id) {
      getInvestorData()
    }
  }, [id])

  const getInvestorData = async () => {
    const { data } = await getResult({ id }).unwrap()
    setInvestorData(data)
  }

  document.title = "Investor Details | Prachay"

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <div className="d-flex align-items-center gap-2 mb-4 pt-3">
            <Link to={"/investor-management"}>
              <img src={leftArrow} alt="" />
            </Link>
            <div className="page-title-name">Investor Details</div>
          </div>
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody className="pt-4">
                  {isFetching ? (
                    <LoaderComponent />
                  ) : (
                    <>
                      <div className="d-flex align-items-center mb-4 justify-content-between">
                        <CardTitle className="">
                          {investorData &&
                            investorData.entity_type === "INDIVIDUAL"
                            ? "Personal Details"
                            : "Entity Details"}
                        </CardTitle>
                        {investorData && (
                          <div className="code-status">
                            {getInvestorsStatus(
                              investorData?.status,
                              investorData.deleted_at
                            )}
                          </div>
                        )}
                      </div>
                      <NonIndividualView investorData={investorData} />
                    </>
                  )}
                </CardBody>
              </Card>

              {investorData?.kycRaisedQueries.length > 0 && (
                <Card>
                  <CardBody className="pt-4">
                    <div className="d-flex align-items-center mb-4 justify-content-between">
                      <CardTitle className="">Raised Queries</CardTitle>
                    </div>
                    <RaisedQueries
                      investorData={investorData}
                      data={investorData?.kycRaisedQueries}
                    />
                  </CardBody>
                </Card>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  )
}

export default InvestorManagementInviteView
